import type { Company } from '@/shared/api'
import { cn } from '@/shared/lib/cn'
import { companyColor } from '../model/colors'
import s from './CompanyAvatar.module.css'

type CompanyAvatarProps = {
  company: Pick<Company, 'initials' | 'colorKey'>
  size: 24 | 32
  className?: string
}

/**
 * Аватар компании — цветной квадрат со скруглением и инициалами. Два размера в макете
 * (prototype/Prototype.dc.html): 24px в свитчере шапки (строка 127, radius 5, шрифт 11px)
 * и 32px в поповере компаний (строки 142/148/153/158, radius 8, шрифт 12px) — это два
 * самостоятельных пресета, не один масштабируемый размер.
 */
export function CompanyAvatar({ company, size, className }: CompanyAvatarProps) {
  return (
    <span
      className={cn(s.root, size === 32 ? s.md : s.sm, className)}
      style={{ background: companyColor(company) }}
    >
      {company.initials}
    </span>
  )
}
